export const MARKER_CLASS = 'engine-state-marker';
export const TOOLTIP_ATTR = 'data-tooltip';
